export enum UserShopType {
  ShopifyShop = 'ShopifyShop',
  BigCommerceShop = 'BigCommerceShop',
  WooCommerceShop = 'WooCommerceShop',
  CustomShop = 'CustomShop',
}
